import { render, staticRenderFns } from "./AddPerms.vue?vue&type=template&id=13b80bef&scoped=true&"
import script from "./AddPerms.vue?vue&type=script&lang=js&"
export * from "./AddPerms.vue?vue&type=script&lang=js&"
import style0 from "./AddPerms.vue?vue&type=style&index=0&id=13b80bef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b80bef",
  null
  
)

export default component.exports